<template>
  <myhead :value="value" @next="next" @lookmore="more">订单<span v-if="count" class="C888 a345">({{ count }})</span></myhead>
  <div class="searchb">
    <Search :value="keyword" @click="handelSearch(url)"></Search>
    <div class="navList">
      <div class="nav_item size16" v-for="item,index in navList" :key="index" @click="tabNav(index)" :class="index == active ?'activeCss':''">
        {{ item.title }}
        <div class="nav_item_status" :class="index == active ?'nav_item_active':''"></div>
      </div>
    </div>

  </div>
  <div class="ordercontainer">
    <All :status="active" :keyword="keyword" @updatecount="updatecount"></All>
    <WsTabbar></WsTabbar>
  </div>
</template>
<script>
import { ref, onMounted, onBeforeUnmount } from "vue";
import All from "./order/list.vue";
import Search from "@/components/Search.vue";
import { useRouter, useRoute } from 'vue-router'

export default {
  components: {
    All,
    Search,
  },
  setup () {
    const navList = [
      {
        id: 0,
        title: '全部'
      },
      {
        id: 1,
        title: '待收货',
      }, {
        id: 2,
        title: '待评价',
      }, {
        id: 3,
        title: '待结账',
      }, {
        id: 4,
        title: '客服中',
      }
    ];

    const active = ref(sessionStorage.getItem('order_active') || 0);
    const keyword = ref("");
    const count = ref(null);
    const timer = ref(null);
    const scrollEnd = ref(0);

    const tabNav = (index) => {
      active.value = index;
      sessionStorage.setItem('order_active', active.value);
      clickTab();
    };

    const handelSearch = () => {
      router.push({
        path: '/shop/search',
        query: { type: 'order' }
      });
    };

    const updatecount = (val) => {
      count.value = val;
    };

    const clickTab = () => {
      if (keyword.value && keyword.value !== "") {
        router.replace({
          path: '/shop/order',
          query: {
            active: active.value,
            keyword: keyword.value,
          },
        });
      } else {
        router.replace({
          path: '/shop/order',
          query: {
            active: active.value,
          },
        });
      }
    };

    const next = () => {
      history.forward();
    };

    const onScroll = () => {
      if (timer.value) {
        clearTimeout(timer.value);
      }
      timer.value = setTimeout(() => {
        const scrollTop = document.getElementById('containerScroll').scrollTop;
        scrollEnd.value = scrollTop;
      }, 500);
    };

    const router = useRouter();
    const route = useRoute();


    onMounted(() => {
      if (router.currentRoute.value.query.type > -1) {
        active.value = router.currentRoute.value.query.type;
        clickTab();
      }
      if (route.query.search) {
        keyword.value = route.query.search
      }
    });

    const query = router.currentRoute.value.query;

    if (query.type > -1) {
      active.value = query.type;
      sessionStorage.setItem('order_active', active.value);
    }

    onBeforeUnmount(() => {
      const data = {
        active: active.value,
        sc: scrollEnd.value,
      };
      sessionStorage.setItem('orderSc', JSON.stringify(data));
    });

    return {
      navList,
      active,
      keyword,
      count,
      timer,
      scrollEnd,
      tabNav,
      handelSearch,
      updatecount,
      clickTab,
      next,
      onScroll,
    };
  }
};
</script>
<style scoped lang="scss">
.navList{
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  font-weight: bold;
  .nav_item{
    .nav_item_status{
      width: 100%;
      height: 5px;
      padding-top: 5px;
      border-radius: 20%;
    }
    .nav_item_active{
      background-color: #3f7c93;
    }
  }
}
.activeCss{
  color: #3F7C93;
}

.gray{ box-shadow: 0 -2px 25px 1px rgba(0,0,0,.1);}
.ordercontainer {
  padding: 0 4vw 60px;
}
.ordercontainer .van-tab--active {
  color: #3f7c93;
  font-size: 16px;
}
.order-list {
  padding: 3.2vw;
  background-color: #fff;
  border-radius: 2.1333vw;
  margin-bottom: 2.6667vw;
  .lookbar {
    margin-bottom: 2.6667vw;
  }
  .order-list-look {
    font-size: 14px;
    color: #3f7c93;
  }
  .order-list-p p {
    &:first-child {
      color: #333333;
      font-size: 14px;
    }
    &:last-child {
      color: #999999;
      font-size: 12px;
      margin-left: 2.1333vw;
    }
  }
  img {
    display: block;
    width: 26.6667vw;
    height: 26.6667vw;
    object-fit: cover;
  }
  .order-info {
    padding-left: 1vw;
    p {
        &:first-child {
            font-size: 14px;
            color: #333333;
        }
        &:nth-child(2) {
            font-size: 12px;
            color: #999999;
            margin-top: 2.6667vw;
            margin-bottom: 3.4667vw;
        }
    }
    .order-info-btn {
        a {
            &:first-child {
                font-size: 3.2vw;
                color: #999999;
            }
            &:nth-child(2) {
                padding: 1.3333vw 3.2vw;
                font-size: 3.7333vw;
                color: #333333;
                border: 1px solid #CCCCCC;
                border-radius: 4vw;
                margin-right: 3vw;
                margin-left: 3vw;
            }
            &:last-child {
                padding: 1.3333vw 3.2vw;
                font-size: 3.7333vw;
                color: #3F7C93;
                border: 1px solid #CCCCCC;
                border-radius: 4vw;
            }
        }
    }
  }
}
.smallcount {
  font-size: 14px;
}
.searchb {
  position: sticky;
  top: 0;
  z-index: 4;
  background-color: #fff;
  padding: 3.2vw 4vw 3.2vw;
}
</style>